// Youssef Selkani
// 2019

import React, { Component } from 'react'
import { Icon, Button, Label, Message, Loader } from 'semantic-ui-react'
import '../App.css'

export default class SideBar extends Component {
  render () {
    let { appname, description, data, error, loading } = this.props

    return (
      <div style={{ width: '100%' }}>
        <div className='sidebar-left'>
          {loading && <Loader size='small' inline active />}
          {!loading && (
            <div className='mb'>
              <h2>{appname}</h2>
              <p>{description}</p>
            </div>
          )}

          {error && (
            <div className='mtbs'>
              <Message>
                <b>{error}</b>
              </Message>
            </div>
          )}
          {data.code === 200 && !loading && (
            <div>
              <Label size='large' style={{ backgroundColor: '#F4D271' }}>
                Premium
              </Label>
              <div className='mtbs'>
                <p>
                  <b>subscription_id:</b> {data.ID}
                </p>
              </div>
              <div className='mt'>
                <Button
                  fluid
                  href='https://docs.google.com/forms/d/e/1FAIpQLSelo_I3aQnFVKljbn4RZXXFrQ4aQGMR0d8rK13r9S5z1hLu4A/viewform'
                  target='_blank'
                  rel='noopener noreferrer'
                  style={{ backgroundColor: '#333', color: '#fff' }}>
                  <Icon name='code' />
                  Request Build
                </Button>
              </div>
            </div>
          )}
          {data.code !== 200 && !loading && (
            <div className='mt'>
              <Button href='/pricing' style={{ backgroundColor: '#F4D271', color: '#000' }}>
                <Icon name='star' />
                Upgrade
              </Button>
            </div>
          )}
        </div>
      </div>
    )
  }
}
